import * as React from 'react'

import type { ClubhouseOnlineCountSubscription } from '@web/gen/clubhouses'
import { useClubhouseOnlineCountSubscription } from '@web/gen/clubhouses'

export const useClubhouseOnlineCount = (clubhouseId: string) => {
  const [onlineCloubhouseCount, setOnlineCloubhouseCount] = React.useState(0)

  const variables = React.useMemo(() => ({ input: { id: clubhouseId } }), [clubhouseId])

  useClubhouseOnlineCountSubscription({
    variables,
    callback: React.useCallback((data: ClubhouseOnlineCountSubscription | null) => {
      if (data?.clubhouseOnlineCount) {
        setOnlineCloubhouseCount(data.clubhouseOnlineCount)
      }
    }, []),
  })

  return onlineCloubhouseCount
}
